(function () {
  class SymbolLandAnimator extends PIXI.Container {
    constructor() {
      super();
      this.visible = false;
      this._trackInfo = undefined;

      Reflex.registerEventHandler(
        "orientationChange",
        this.onOrientationChange.bind(this)
      );
      const self = this;
      Reflex.addToUpdate(function (delta, time) {
        self.update(delta, time);
      });
    }

    update() {
      if (this._trackInfo) {
        const symPos = this._trackInfo.getPosition();
        this.position.set(
          symPos.x + this._positionOffset.x,
          symPos.y + this._positionOffset.y
        );
      }
    }

    play(trackInfo, loop, onCellAnimFinishedCb) {
      this._trackInfo = trackInfo;
      this.initialiseSymbolMovie(trackInfo.getPosition(), trackInfo.clipBounds);
      trackInfo.showSymbol(false);

      const self = this;
      this._movie.onComplete = function () {
        onCellAnimFinishedCb(self);
      };
      this._movie.gotoAndPlay(0);
    }

    initialiseSymbolMovie(symPos, clipBounds) {
      this.visible = true;
      this._movie.gotoAndStop(0);
      this.position.set(
        symPos.x + this._positionOffset.x,
        symPos.y + this._positionOffset.y
      );
    }

    getTrackInfo() {
      return this._trackInfo;
    }

    finalise() {
      this.visible = false;

      // this._trackInfo.showSymbol(true);
      // need to do the following when cpu throttled as land symbols are incorrect and trackinfo sym incorrect
      const { reel, row } = this._trackInfo.cell;
      gameController.slotMachine._reelVisuals[reel].showSymbol(row, true);

      this._trackInfo = undefined;
    }

    untrack() {
      if (this._trackInfo) {
        this._trackInfo.untrack();
      }
    }

    skip() {
      this.untrack();
    }

    onOrientationChange() {
      if (this._trackInfo !== undefined) {
        let symPos = this._trackInfo.getPosition();
        this.position.set(
          symPos.x + this._positionOffset.x,
          symPos.y + this._positionOffset.y
        );
      }
    }
  }

  let create = function () {
    return new SymbolLandAnimator();
  };

  let initialise = function (json, instance) {
    instance._movie = resourceManager.createObject(
      "movie",
      json.playData.definition,
      instance.name,
      {
        definition: json.playData.definition,
      }
    );
    instance._movie.loop = false;
    instance._movie.gotoAndStop(0);
    instance._movie.anchor.set(0.5);

    instance._positionOffset = { x: 0, y: 0 };
    if (json.playData.posOffset) {
      instance._positionOffset = json.playData.posOffset;
    }
  };

  let getRequiredFiles = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "symbolLandAnimator",
    create,
    initialise,
    getRequiredFiles
  );
})();
